import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";

import { vsObjectName as machineObjectName } from "./../../../machines/sanmanuel/configs/machine";
import { vsObjectName as projectName } from "./project";

export const vsObjectName = "projectMachines";

export const vsMachineColumnSetName = `${vsObjectName}.machine`;
export const vsProjectColumnSetName = `${vsObjectName}.project`;

projectMachineConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function projectMachineConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  registerColumnDefinitionSets(columnDefinitionSetServiceProvider);
  registerGrid(recordGridViewServiceProvider);
}

function registerGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ): GridConfiguration => {
      return {
        defaultSort: "Id",
        gridDataSource: new RecordDataSource(
          serverUtility,
          `/api/project/machines`
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Project Machines",
        nameSingular: "Project Machine",
        showAddButton: false,
        columnDefinitionSet: vsObjectName,
      };
    },
  ]);
}

function registerColumnDefinitionSets(
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsMachineColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) =>
        columnDefinitionSetService.getColumnDefinitionSet(machineObjectName),
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsProjectColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      ColumnDefinitionServiceName,
      (
        columnDefinitionSetService: ColumnDefinitionSetService,
        columnDefinitionService: ColumnDefinitionService
      ) => {
        const columns =
          columnDefinitionSetService.getColumnDefinitionSet(projectName);
        const startDateColumn = columns.find((c) => c.field === "StartDate");
        if (startDateColumn) {
          columns.splice(
            columns.indexOf(startDateColumn),
            1,
            columnDefinitionService.getDateColDef({
              header: startDateColumn.headerName,
              field: "ProjectStartDate",
            })
          );
        }
        

        const endDateColumn = columns.find((c) => c.field === "EndDate");
        if (endDateColumn) {
          columns.splice(
            columns.indexOf(endDateColumn),
            1,
            columnDefinitionService.getDateColDef({
              header: endDateColumn.headerName,
              field: "ProjectEndDate",
            })
          );
        }

        return columns;
      },
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    (columnDefinitionSetService: ColumnDefinitionSetService) => {
      const machineColumns = columnDefinitionSetService.getColumnDefinitionSet(
        vsMachineColumnSetName
      );
      const projectColumns = columnDefinitionSetService.getColumnDefinitionSet(
        vsProjectColumnSetName
      );
      return [...projectColumns, ...machineColumns];
    },
  ]);
}
